import { render, staticRenderFns } from "./OnofficeCredentials.vue?vue&type=template&id=f161330c&"
import script from "./OnofficeCredentials.vue?vue&type=script&lang=js&"
export * from "./OnofficeCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports